module.exports = __webpack_public_path__ + "media/images/icon__dhi--rb-gray@2x-bbf3990889a74adee85f8bbb53698b79.png";